<template>
    <router-link
        v-if="item['vueRouting']"
        :class="classItem(item)"
        :to="item['url']"
        :data-bot="item['databot']"
        :data-upsell="item['data-upsell']"
    >
        <menu-link-item :item="item" />
    </router-link>
    <a
        v-else-if="!item['call'] && !item['sub']"
        :href="item['url']"
        :class="classItem(item)"
        :data-bot="item['databot']"
        :data-upsell="item['data-upsell']"
        :target="item['isExternal'] ? '_blank' : ''"
    >
        <menu-link-item :item="item" />
    </a>
    <a
        v-else
        href="javascript:;"
        :onclick="item['call']"
        :class="classItem(item)"
        :data-bot="item['databot']"
        :data-upsell="item['data-upsell']"
    >
        <menu-link-item :item="item" />
    </a>
</template>

<script>
import MenuLinkItem from 'vcomponents/menu/MenuLinkItem.vue';
export default {
    components: {
        MenuLinkItem,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        itemId: {
            type: String,
            required: false,
            default: '',
        },
        activeItem: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        classItem(item) {
            const classes = {};

            if (this.activeItem && this.itemId) {
                classes['current'] = this.itemId === this.activeItem;
            }

            if (typeof item['class'] === 'string') {
                const arrayClass = item['class'].split(' ');
                arrayClass.forEach((classElt) => {
                    classes[classElt] = true;
                });
            }

            return classes;
        },
    },
};
</script>
<style scoped lang="scss">
.upsell-action {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);
}
</style>
